__turbopack_context__.v({
  "composition": "A2RoIq_composition",
  "corner": "A2RoIq_corner",
  "cornerBottomLeft": "A2RoIq_cornerBottomLeft" + " " + "A2RoIq_corner",
  "cornerBottomRight": "A2RoIq_cornerBottomRight" + " " + "A2RoIq_corner",
  "cornerTopLeft": "A2RoIq_cornerTopLeft" + " " + "A2RoIq_corner",
  "cornerTopRight": "A2RoIq_cornerTopRight" + " " + "A2RoIq_corner",
  "listingImage": "A2RoIq_listingImage",
  "listingTitle": "A2RoIq_listingTitle",
  "lit": "A2RoIq_lit",
  "matchCard": "A2RoIq_matchCard",
  "phone": "A2RoIq_phone",
  "photo": "A2RoIq_photo",
  "scan": "A2RoIq_scan",
  "stage": "A2RoIq_stage",
});
